import { render } from "./EsPromotion.vue?vue&type=template&id=15f296e4&scoped=true"
import script from "./EsPromotion.vue?vue&type=script&lang=js"
export * from "./EsPromotion.vue?vue&type=script&lang=js"

import "./EsPromotion.vue?vue&type=style&index=0&id=15f296e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f296e4"]])

export default __exports__